export * from "./Grid";
export * from "./Dimensions";

export type LocationPosition = {
    latitude: number;
    longitude: number;
};

export type IGoogleAddressAutocompleteProps = any;

// TODO: rename to AddressDetails
export type AddressLocation = {
    name: string;
    locationId?: string; // TODO: rename to addressId
    position?: LocationPosition;
    countryIsoCode: string; // TODO: try to make optional
};

export type SelectOption<TValue = string | number> = {
    label: string;
    value: TValue;
    disabled?: boolean;
    [property: string]: any;
};

export * from "./address-autocomplete";
export { RestrictToAreaOptions } from "./address-autocomplete/AddressAutocomplete.types";
export * from "./dropdown";
export * from "./GoogleMapsApiProvider";

export * from "./utils";
